import { render, staticRenderFns } from "./OrderClaimIndex.vue?vue&type=template&id=3f30272f&"
import script from "./OrderClaimIndex.vue?vue&type=script&lang=js&"
export * from "./OrderClaimIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports